class ToneService {
    constructor() {
      this.ringtone = new Audio('/assets/sounds/ringtone.mp3')
      this.ringback = new Audio('/assets/sounds/ringback.mp3')
  
      this.ringtone.loop = true
      this.ringback.loop = true
  
      this._outputId = null
      this._unlocked = false
  
      this._ctx = null
      this._gain = null
  
      this._ringtonePlaying = false
      this._ringbackPlaying = false
    }
  
    async unlock() {
      if (this._unlocked) return
      this._unlocked = true
  
      try {
        await this._primeAudioEl(this.ringtone)
        await this._primeAudioEl(this.ringback)
      } catch (e) {}
  
      try {
        this._ctx = this._ctx || new (window.AudioContext || window.webkitAudioContext)()
        await this._ctx.resume().catch(() => {})
        this._gain = this._gain || this._ctx.createGain()
        this._gain.gain.value = 0.18
        this._gain.connect(this._ctx.destination)
      } catch (e) {}
    }
  
    async setOutputDevice(outputId) {
      this._outputId = outputId || null
      await this._applySinkId(this.ringtone)
      await this._applySinkId(this.ringback)
    }
  
    async startRingtone() {
      if (this._ringtonePlaying) return
      this._ringtonePlaying = true
      await this._applySinkId(this.ringtone)
      await this._safePlay(this.ringtone)
    }
  
    stopRingtone() {
      this._ringtonePlaying = false
      this._safeStop(this.ringtone)
    }
  
    async startRingback() {
      if (this._ringbackPlaying) return
      this._ringbackPlaying = true
      await this._applySinkId(this.ringback)
      await this._safePlay(this.ringback)
    }
  
    stopRingback() {
      this._ringbackPlaying = false
      this._safeStop(this.ringback)
    }
  
    stopAllCallTones() {
      this.stopRingtone()
      this.stopRingback()
    }
  
    async playDtmf(digit, ms = 120) {
      const d = String(digit ?? '').trim()
      if (!d) return
  
      await this.unlock().catch(() => {})
  
      if (!this._ctx || !this._gain) return
  
      const freqs = this._dtmfFreqs(d)
      if (!freqs) return
  
      const now = this._ctx.currentTime
      const stopAt = now + ms / 1000
  
      const o1 = this._ctx.createOscillator()
      const o2 = this._ctx.createOscillator()
  
      o1.type = 'sine'
      o2.type = 'sine'
      o1.frequency.value = freqs[0]
      o2.frequency.value = freqs[1]
  
      const g = this._ctx.createGain()
      g.gain.setValueAtTime(0, now)
      g.gain.linearRampToValueAtTime(1, now + 0.01)
      g.gain.setValueAtTime(1, stopAt - 0.02)
      g.gain.linearRampToValueAtTime(0, stopAt)
  
      o1.connect(g)
      o2.connect(g)
      g.connect(this._gain)
  
      try {
        o1.start(now)
        o2.start(now)
        o1.stop(stopAt)
        o2.stop(stopAt)
      } catch (e) {}
    }
  
    _dtmfFreqs(d) {
      const map = {
        '1': [697, 1209],
        '2': [697, 1336],
        '3': [697, 1477],
        '4': [770, 1209],
        '5': [770, 1336],
        '6': [770, 1477],
        '7': [852, 1209],
        '8': [852, 1336],
        '9': [852, 1477],
        '*': [941, 1209],
        '0': [941, 1336],
        '#': [941, 1477],
        A: [697, 1633],
        B: [770, 1633],
        C: [852, 1633],
        D: [941, 1633]
      }
      return map[d] || map[d.toUpperCase()] || null
    }
  
    async _applySinkId(audioEl) {
      if (!audioEl) return
      if (!this._outputId) return
      if (typeof audioEl.setSinkId !== 'function') return
      try {
        await audioEl.setSinkId(this._outputId)
      } catch (e) {}
    }
  
    async _primeAudioEl(audioEl) {
      if (!audioEl) return
      try {
        audioEl.muted = true
        await audioEl.play()
        audioEl.pause()
        audioEl.currentTime = 0
        audioEl.muted = false
      } catch (e) {}
    }
  
    async _safePlay(audioEl) {
      if (!audioEl) return
      try {
        audioEl.currentTime = 0
      } catch (e) {}
      try {
        await audioEl.play()
      } catch (e) {}
    }
  
    _safeStop(audioEl) {
      if (!audioEl) return
      try {
        audioEl.pause()
      } catch (e) {}
      try {
        audioEl.currentTime = 0
      } catch (e) {}
    }
  }
  
  const toneService = new ToneService()
  export default toneService
  